export const useSxStyles = () => {
  return {
    table: {
      borderCollapse: 'collapse',
      cellSpacing: '0px',
      '& thead': {
        '& th': {
          padding: 0,
          textAlign: 'left',
          fontSize: '13px',
          fontWeight: 'bold',
        },
      },
      '& tbody': {
        '& td': {
          textAlign: 'left',
          fontSize: '13px',
          padding: '0px',
        },
      },
    },
    thCompetency: {
      width: '310px',
      minWidth: '310px',
    },
    thCompLevel: {
      width: '190px',
      minWidth: '190px',
    },
    thTarget: {
      width: '190px',
      minWidth: '190px',
    },
    thInfo: {
      width: '435px',
      minWidth: '435px',
    },
    cssScaleHd: {
      height: '20px',
      display: 'inline-block',
      width: '29px',
      textAlign: 'center',
      border: '1px solid #ccc',
      borderTop: 'none',
    },
    cssScale: {
      height: '22px',
      display: 'inline-block',
      width: '29px',
      textAlign: 'center',
      border: '1px solid #ccc',
    },
    circle: {
      color: '#ffffff',
    },
    iconColor: {
      color: '#1fa67a',
    },
  };
};
